const js = {}; export default js;
const imp_nbxw623t = {}; export { imp_nbxw623t as hooks };
import js_ox2wxhdo57mgxmlzabp7pn5ifu from "./WSRWeb.Admin.Form13FReviewLive/188_nncxinlhxc45m4ihk6wevjw2me.js"; imp_nbxw623t["WSRWeb.Admin.Form13FReviewLive.CopyText"] = js_ox2wxhdo57mgxmlzabp7pn5ifu;
